import React from 'react'
import FallBackImg from 'assets/images/svg/image_placeholder.svg'

//const baseURL = "http://192.168.1.7:9001"

interface Props extends React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    src: string;
    alt?: string;

}

const ServerImage = ({src, alt = 'default-server-img', ...props}: Props) => {
    const [isError, setError] = React.useState(false)

    React.useEffect(() => setError(false),[src])

    if (isError) return <img src={FallBackImg} alt={alt} {...props} />
    return <img src={src} alt={alt} {...props} onError={() => setError(true)}/>
}

export default ServerImage
